// const constant = "http://117.218.59.50:8000/api/"; // Local
const constant = process.env.REACT_APP_BASE_API;
// const constant1 = process.env.REACT_APP_BASE_HOST;
export const ServiceProvider = {
  auth: {
    login: `${constant}auth/login/v1`,
  },

  company: {
    base: `${constant}company`,
    create: `${constant}company/create`,
    update: `${constant}company/update/`, // append id in service
    delete: `${constant}company/delete/`,
    bulkCreate: `${constant}company/bulk_create`,
    bulkDelete: `${constant}company/bulk_delete`,
    getAll: `${constant}company`,
    search: `${constant}company/search`,
    export: `${constant}company/export`,
    indexGroups: `${constant}get_all/index_groups`,
    segment: `${constant}segments/get_all`,
    exchange: `${constant}exchanges/get_all`,
    assign:`${constant}company_index_groups/update`
  },


  liveService: {
    base: `${constant}live_service`,
    getAll: `${constant}live_service/get_all`,
    getById: `${constant}live_service/get/`, // append id in service
    insert: `${constant}live_service/insert`,
    update: `${constant}live_service/update/`, // append id
    delete: `${constant}live_service/delete?cmp_id=`, // append id
    start: `${constant}start-live-ticks`, // append id
    stop: `${constant}stop-live-ticks`, // append id
  },

  index: {
    base: `${constant}index`,
    getAll: `${constant}get_all/index_groups`,
    insert: `${constant}index/insert`,
    update: `${constant}index/update/`, // append id
    delete: `${constant}index/delete`, // append id
    addGroup: `${constant}company_index_groups/add`
  },

  schedule: {
    base: `${constant}schedule`,
    getAll: `${constant}schedule/get_all`,
    insert: `${constant}schedule/create`,
    update: `${constant}schedule/update`, // append id
    start_or_stop_job: `${constant}schedule_job`, // append id
    delete: `${constant}schedule/delete`, // append id
  },
  scheduleSts: {
    base: `${constant}schedule_sts`,
    getAll: `${constant}schedule_sts/get_all`,
    insert: `${constant}schedule_sts/create`,
    update: `${constant}schedule_sts/update/`, // append id
    delete: `${constant}schedule_sts/delete`, // append id
  },

};
